import type { PanelLockedFilter, PanelAppliedFilter } from './types';

export const getProcessedJsonFilter = (
  tableFilter: PanelAppliedFilter,
): any => {
  const {
    tags: selectedTags,
    panelResults: selectedResults,
    serialNo,
    priorityOrderRange,
    expr,
    partnerUniversity,
  } = tableFilter;
  const processedFilter = {
    ...(!selectedTags?.length
      ? {}
      : {
          tags: {
            all: selectedTags,
          },
        }),
    ...(!selectedResults?.length
      ? {}
      : {
          panelResults: {
            all: selectedResults,
          },
        }),
    ...(serialNo ? { serialNo } : {}),
    ...(priorityOrderRange && JSON.stringify(priorityOrderRange) !== '{}'
      ? {
          priorityRange: [
            priorityOrderRange?.min ?? 1,
            priorityOrderRange?.max ?? 999,
          ],
        }
      : {}),
    ...(expr && expr !== '' ? { expr } : {}),
    ...(partnerUniversity && partnerUniversity !== ''
      ? { partnerUniversity }
      : {}),
  };

  return processedFilter;
};

export const getMergeFilters = (
  appliedFilter: PanelAppliedFilter,
  lockedFilter?: PanelLockedFilter,
): PanelAppliedFilter => {
  const mergedFilter: PanelAppliedFilter = {
    tags: lockedFilter?.tags ?? appliedFilter.tags ?? [],

    panelResults:
      lockedFilter?.panelResults ?? appliedFilter.panelResults ?? [],
    priorityOrderRange:
      lockedFilter?.priorityOrderRange ??
      appliedFilter?.priorityOrderRange ??
      undefined,
    serialNo: lockedFilter?.serialNo ?? appliedFilter?.serialNo,
    expr: lockedFilter?.expr ?? appliedFilter?.expr,

    partnerUniversity:
      lockedFilter?.partnerUniversity ?? appliedFilter.partnerUniversity,
  };

  return mergedFilter;
};

export const isEmptyTableFilter = (
  tableFilter?: PanelAppliedFilter,
): boolean => {
  if (!tableFilter) return true;
  const {
    expr,
    serialNo,
    panelResults,
    priorityOrderRange,
    tags,
    partnerUniversity,
  } = tableFilter;

  const isEmpty =
    (JSON.stringify(priorityOrderRange) === '{}' || !priorityOrderRange) &&
    !expr &&
    !serialNo &&
    !panelResults?.length &&
    !tags?.length &&
    !partnerUniversity;
  return isEmpty;
};
